import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Default api - uses user token if available
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const userToken = localStorage.getItem("ala_user_token");
  if (userToken) config.headers.Authorization = `Bearer ${userToken}`;
  return config;
});

// Admin api - always uses admin token
export const apiAdmin = axios.create({ baseURL: API });
apiAdmin.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("ala_token");
  if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  return config;
});

export const formatCLP = (n) => {
  if (n === null || n === undefined) return "Cotizar";
  return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(n);
};

export const WHATSAPP_NUMBER = "+56945517311";
export const WHATSAPP_LINK = (msg = "Hola, quiero cotizar mi proyecto personalizado") =>
  `https://wa.me/56945517311?text=${encodeURIComponent(msg)}`;
export const INSTAGRAM_URL = "https://instagram.com/a.l.a_grafica_spa_copiapo";
